import {BillingLine} from '../../../billing-line/billing-line.model';
import {DiscoPricingItemMapper} from './disco-pricing-item.mapper';
import { ProductPricingV2 } from '../../../productv2/productpricingv2.model';
import { ProductV2 } from '../../../productv2/productv2.model';
import { DiscoVtRenewalPricingItemInitializer } from 'src/app/components/article-selection-form/disco/vt/disco.vt.renewal-pricing-item-initializer';


export class DiscoVtPricingItemMapper extends DiscoPricingItemMapper {

    LABEL_AUCUN = 'Aucun';

    mapPricingItemFromProduct(product: ProductV2, cc: BillingLine, referential: any, idx: string) {
        let pricingItem = this.mapProductToPricingItemWithCustomerContract(product, cc, idx);
        const frDiscoPricingItemInitializer = new DiscoVtRenewalPricingItemInitializer(new DiscoPricingItemMapper(true));

        const prefilledInputs = frDiscoPricingItemInitializer.getPrefilledInputs(product.priceList?.productPricings, referential, cc);
        prefilledInputs['numberOfChanges'] = prefilledInputs['numberOfChanges']
            .sort((a, b) => a.key?.localeCompare(b.key))
            .map(({ key, value }) => ({
                key: key?.toLowerCase(),
                value: value?.toLowerCase()
            }));
        const userInputs = frDiscoPricingItemInitializer.initUserInputs(cc, prefilledInputs, pricingItem);

        return pricingItem.copyWith({ userInputs, prefilledInputs });
    }

     findMatchingProductPricing(productPricings: ProductPricingV2[], customerContract: BillingLine) {
        return productPricings?.find(pp => pp.frequency === customerContract.serviceFrequency
            && pp.numberOfChange === customerContract.numberOfChanges
            && Number(pp.minQuantity) <= customerContract.weeklyQuantity
            && Number(pp.maxQuantity) >= customerContract.weeklyQuantity
        );
    }

    completeProductPricingsWithProduct(cmcProduct: ProductV2, product: ProductV2) {

        let standardProductPricings = this.getStandardProduct(cmcProduct.priceList.productPricings, product.priceList?.productPricings);
        if(standardProductPricings){
            standardProductPricings.forEach(pp => {
                pp['type'] = 'STANDARD';
            });
            cmcProduct.priceList.productPricings = cmcProduct.priceList.productPricings.concat(standardProductPricings);
            cmcProduct['isCmcWithStandardProductPricing'] = true;
        }
    }

    getStandardProduct(cmcProductPricings: ProductPricingV2[], standardProductPricings: ProductPricingV2[]): ProductPricingV2[] {
        return standardProductPricings.filter(standardProductPricing =>
            !cmcProductPricings.some(cmcProductPricing =>
                cmcProductPricing.frequency === standardProductPricing.frequency
                && cmcProductPricing.numberOfChange === standardProductPricing.numberOfChange
            )
        );
    }

    getPrefilledInputs(cc: BillingLine, referential: any, productPricings: ProductPricingV2[]): any {
        let prefilledInputs = super.getPrefilledInputs(cc, referential, productPricings);
        const numberOfChange = { key: cc.numberOfChanges ?? this.LABEL_AUCUN, value: cc.numberOfChanges ?? this.LABEL_AUCUN };
        Object.assign(prefilledInputs, {
            numberOfChanges: [numberOfChange],
        })
        return prefilledInputs;
    };

    extendsDevicePricingItemUserInputs(userInputs: any, cc: BillingLine) {
         let stockVT= {key:cc.garmentStock,value:cc.garmentStock}
       const numberOfChange = { key: cc.numberOfChanges ?? this.LABEL_AUCUN, value: cc.numberOfChanges ?? this.LABEL_AUCUN };
        Object.assign(userInputs, {
            quantity: cc.weeklyQuantity,
           numberOfChange: numberOfChange,
           stockVT
        })
        return userInputs;
    }

}
